import type { StaticImageData } from 'next/image';
import React from 'react';

import { MediaComponent } from '@/components/Media';
import { BORDER_RADIUS } from '@/enums/border-radius';
import type { MediaBlock as MediaBlockProps } from '@/payload-types';
import { cn } from 'src/utilities/cn';

type Props = MediaBlockProps & {
  breakout?: boolean
  captionClassName?: string
  className?: string
  enableGutter?: boolean
  imgClassName?: string
  staticImage?: StaticImageData
  disableInnerContainer?: boolean
}

export const MediaBlock: React.FC<Props> = (props) => {
  const {
    captionClassName,
    className,
    enableGutter = true,
    imgClassName,
    media,
    staticImage,
    disableInnerContainer,
    height,
    width,
    borderRadius,
    lazyLoad
  } = props;

  return (
    <div
      className={cn(
        '',
        {
          container: enableGutter,
        },
        className,
      )}
    >
      <MediaComponent
        imgClassName={cn('border border-border', imgClassName, {
          'rounded-lg': borderRadius === BORDER_RADIUS.LG,
          'rounded-2xl': borderRadius === BORDER_RADIUS['2xl'],
          'rounded-3xl': borderRadius === BORDER_RADIUS['3xl'],
          'rounded-full': borderRadius === BORDER_RADIUS.FULL,
        })}
        priority={!lazyLoad}
        resource={media}
        src={staticImage}
        style={{
          width,
          height
        }}
      />
    </div>
  );
};
